function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.977 120.992C44.8251 124.962 37.5223 127.675 28.4351 129.225C23.5559 130.058 18.6058 130.801 13.6723 130.398C3.48066 129.564 -3.56177 124.826 1.93174 114.608C5.97933 107.08 10.4257 99.7687 15.2163 92.6912C20.0246 85.5886 25.1797 78.7231 30.624 72.0972C36.0867 65.4504 41.8402 59.0432 47.8326 52.8696C49.3657 51.2904 50.9146 49.7264 52.4778 48.1766C54.1339 46.5366 55.8444 44.9369 57.7411 43.5757C58.7057 42.8838 59.7163 42.2489 60.7787 41.7177C61.877 41.1681 63.106 41.1155 64.236 40.663",
  fill: "#FC497D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.976 50.3294C179.395 45.8479 196.425 35.0188 213.287 24.8729C222.559 19.2935 231.875 13.7242 241.728 9.21458C246.662 6.95731 251.727 4.9656 256.935 3.43519C262.314 1.85525 267.757 1.09808 273.297 0.234884C273.719 0.169117 274.156 0.104199 274.566 0.219206C275.455 0.468387 275.927 1.53885 275.737 2.44088C275.261 4.70508 271.503 5.41563 269.703 6.13218C270.829 6.27056 271.3 8.01027 270.401 8.70317C269.869 9.11461 268.937 9.37291 269.064 10.0332C269.12 10.3277 269.392 10.5246 269.543 10.7827C269.85 11.3031 269.621 11.9696 269.328 12.4975C268.18 14.5559 266.052 16.0408 263.723 16.4083C256.586 17.5355 251.83 19.8096 246.45 24.7151C231.549 38.3054 215.299 50.4209 198.017 60.8267",
  fill: "#F6B9A6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.0613 40.6786C96.4821 40.5527 96.9037 40.4268 97.3245 40.3009C97.4066 40.2768 97.4988 40.2429 97.5304 40.163C97.5504 40.1106 97.5372 40.0515 97.5248 39.9966C96.9466 37.5434 96.3676 35.0902 95.7894 32.6371C95.7094 32.2974 95.6128 31.9303 95.3394 31.7136C95.143 31.5577 94.8859 31.5058 94.6395 31.458C86.864 29.9703 78.4422 30.2392 70.5399 29.8838C69.4241 29.834 68.2851 29.7875 67.2062 30.0832C65.2617 30.6172 64.906 31.6927 64.6288 33.6022C64.1615 36.8303 63.4718 40.0257 62.5657 43.1584",
  fill: "#FC497D"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.8641 39.124C102.965 38.9386 107.059 38.7691 111.122 38.7155C124.191 38.5441 137.689 40.1086 150.852 40.6445C161.665 41.0846 174.089 41.7004 183.65 35.831C191.035 43.8384 196.531 55.4759 198.257 66.2142C186.65 74.2908 172.91 78.3857 159.125 80.7744C152.358 81.9477 145.466 82.9064 138.607 83.2848C130.504 83.7307 122.623 85.1434 114.534 85.7486C111.647 110.637 113.311 136.049 119.421 160.343C106.614 167.565 93.0111 174.999 78.3251 174.712C68.525 174.521 58.9746 169.682 49.2728 169.914C43.3921 170.117 37.3818 172.205 31.5831 173.207C31.7523 148.545 33.131 123.824 37.5459 99.644C39.6233 88.2663 41.8759 76.8529 45.7128 65.9195C48.0529 59.2521 50.5643 52.359 54.9007 46.7001C60.2383 39.7349 66.5552 39.395 74.9547 39.6633C82.8226 39.9143 90.855 39.4875 98.8641 39.124Z",
  fill: "#FF718D"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M181.665 33.6695C181.702 33.4508 181.793 33.2388 181.949 33.0369C182.961 31.7268 184.98 31.4528 186.485 31.0969C188.275 30.6727 190.088 30.3471 191.915 30.1234C193.024 29.9874 194.205 29.8995 195.208 30.3864C196.066 30.8027 196.678 31.5831 197.24 32.3486C203.363 40.6927 207.428 50.5103 208.982 60.7131C209.085 61.3909 209.173 62.1069 208.914 62.7428C208.646 63.4011 208.05 63.8626 207.48 64.2918L202.557 68.0026C201.403 68.8726 199.661 69.7145 198.667 68.6692C198.24 68.2204 198.142 67.5649 198.055 66.9534C197.551 63.3959 196.743 59.8769 195.574 56.4743C194.071 52.096 191.967 47.9398 189.375 44.0944C188.046 42.1224 186.595 40.2331 185.053 38.4198C184.162 37.3714 181.384 35.3228 181.665 33.6695Z",
  fill: "#FC497D"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M241.075 15.9169L249.476 10.7381C249.476 10.7381 251.774 14.7188 254.291 18.6972C256.808 22.6757 248.593 27.6187 245.891 23.876C243.189 20.1333 241.075 15.9169 241.075 15.9169Z",
  fill: "#1B1535"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M250.783 13.4716L242.343 19.7474C242.343 19.7474 239.712 15.9731 236.854 12.2273C233.995 8.48154 242.257 2.46762 245.294 5.95149C248.33 9.43536 250.783 13.4716 250.783 13.4716Z",
  fill: "#1B1535"
});

var _ref9 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 245.517,
  cy: 13.7749,
  rx: 7.46312,
  ry: 7.38558,
  transform: "rotate(0.0784597 245.517 13.7749)",
  fill: "white"
});

var SvgTorso1 = function SvgTorso1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 276,
    height: 175,
    viewBox: "0 0 276 175",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTorso1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/torso-1.45117d02.svg";
export { ForwardRef as ReactComponent };